import React from "react";
import "./servicebanner.css";

const Servicebannerpage = () => {
  return (
    <div className="service-banner-page">
      <h1> Build your digital product with a one-stop shop</h1>
    </div>
  );
};

export default Servicebannerpage;
